// extracted by mini-css-extract-plugin
export default {"avatar_delete":"LocationGroupsAvatarDelete_avatar_delete__ndJBj","button":"LocationGroupsAvatarDelete_button__e7ouR"};